/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Agent
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Agent
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Agent
     */
    dateDeleted?: Date;
}

/**
 * Check if a given object implements the Agent interface.
 */
export function instanceOfAgent(value: object): boolean {
    return true;
}

export function AgentFromJSON(json: any): Agent {
    return AgentFromJSONTyped(json, false);
}

export function AgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Agent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'dateDeleted': json['dateDeleted'] == null ? undefined : (new Date(json['dateDeleted'])),
    };
}

export function AgentToJSON(value?: Agent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'isDeleted': value['isDeleted'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'dateDeleted': value['dateDeleted'] == null ? undefined : ((value['dateDeleted'] as any).toISOString()),
    };
}

